import {
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
  Box,
  TextField,
  Dialog,
  Autocomplete,
} from '@mui/material';
import CustomInput from '../../../../../../components/shared/CustomInput';
import BackButton from '../../../../../../components/shared/BackButton';
import AddSubCategoryInCategory from './Desktop/AddSubCategoryInCategory';

import AddIcon from '@mui/icons-material/Add';
import CancelIcon from '@mui/icons-material/Cancel';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import CustomCard from '../../../../../../components/shared/CustomCard';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import CustomButton from '../../../../../../components/shared/CustomButton';
import Star from '../../../../../../components/shared/Star';

const CategoryMenuAddDesktop = (props) => {
  const {
    today,
    theme,
    AntSwitch,
    // *--- Page
    setPage,
    isSubmitAvailable,
    setIsSubmitAvailable,
    // *--- Data
    categoryAddInputDatas,
    setCategoryAddInputDatas,
    subsidiaryCategory,
    subsidiaryCategoryLoading,
    // *--- Type
    typeCategory,
    typeCategoryLoading,
    // *--- Handle
    handleBackButton,
    handleAddImage,
    handleDeleteImage,
    handleAddSub,
    handleAdd,
    // *--- Sub
    indexSubCategory,
    setIndexSubCategory,
    sub1,
    setSub1,
    sub2,
    setSub2,
    sub3,
    setSub3,
  } = props;
  return (
    <Grid container columns={12} spacing={2}>
      {/* //* Back */}
      <Grid item xs={10} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <BackButton handleClick={handleBackButton} />
        <Typography
          sx={{
            ml: '8px',
            fontSize: '24px',
            fontWeight: '600',
          }}
        >
          Add Category
        </Typography>
      </Grid>
      {/* //* Subsidiary */}
      <Grid item xs={12}>
        <Box sx={{ display: 'flex' }}>
          <Typography sx={{ mb: '16px', fontSize: '16px', fontWeight: '500' }}>
            Subsidiary
          </Typography>
          <Star />
        </Box>

        <FormControl>
          <RadioGroup
            row
            value={categoryAddInputDatas.subsidiaryId}
            onChange={(e) => {
              setCategoryAddInputDatas({
                ...categoryAddInputDatas,
                subsidiaryId: e.target.value,
              });
            }}
          >
            {!subsidiaryCategoryLoading && (
              <>
                {subsidiaryCategory.map((data, index) => (
                  <FormControlLabel
                    value={data.id}
                    control={<Radio />}
                    label={data.name}
                    key={index}
                  />
                ))}
              </>
            )}
          </RadioGroup>
        </FormControl>
      </Grid>
      {/* //* Name */}
      <Grid item xs={6}>
        <Box sx={{ display: 'flex' }}>
          <Typography sx={{ mb: '16px', fontSize: '16px', fontWeight: '500' }}>
            Name
          </Typography>
          <Star />
        </Box>
        <CustomInput
          sx={{ width: '100%', bgcolor: '#FAFAFA' }}
          placeholder="Enter category name"
          value={categoryAddInputDatas.name}
          onChange={(e) => {
            if (e.target.value.length <= 30) {
              setCategoryAddInputDatas({
                ...categoryAddInputDatas,
                name: e.target.value,
              });
            }
          }}
        />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography
            sx={{
              fontSize: '12px',
              fontWeight: '400',
              color: '#9E9D9D',
              mt: '4px',
            }}
          >
            Enter at least 5 character
          </Typography>
          <Typography
            sx={{
              fontSize: '12px',
              fontWeight: '400',
              color: '#9E9D9D',
              mt: '4px',
            }}
          >
            {categoryAddInputDatas.name.length}/30
          </Typography>
        </Box>
      </Grid>
      {/* //* Photo */}
      <Grid item xs={6} sx={{ minHeight: '100%' }}>
        <Box
          sx={{
            display: 'flex',
            gap: 1,
            pb: `${categoryAddInputDatas.photo.length === 0 ? '16px' : '9px'}`,
          }}
        >
          <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>
            Photo
          </Typography>
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: '500',
              color: '#9E9D9D',
            }}
          >
            ( max size : 2MB )
          </Typography>
          {categoryAddInputDatas.isMaxSizePhoto && (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <ErrorOutlineIcon
                sx={{
                  fontSize: '16px',
                  fontWeight: '500',
                  color: theme.palette.warning.main,
                  mr: '4px',
                }}
              />
              <Typography
                sx={{
                  fontSize: '12px',
                  fontWeight: '500',
                  color: theme.palette.warning.main,
                }}
              >
                The photo can't be more than 2MB
              </Typography>
            </Box>
          )}
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'start',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {categoryAddInputDatas.photo.length === 0 && (
              <Box
                sx={{
                  height: '54px',
                  width: '54px',
                  aspectRatio: '1/1',
                  borderRadius: '8px',
                  bgcolor: '#F5F5F5',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderStyle: 'dashed',
                  borderColor: '#9E9D9D',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  document.getElementById('input_img').click();
                }}
              >
                <ImageOutlinedIcon
                  sx={{ color: '#9E9D9D', fontSize: '28px' }}
                />
              </Box>
            )}
            {categoryAddInputDatas.photo.map((input, index) => (
              <Box
                sx={{
                  position: 'relative',
                  overflow: 'visible',
                  padding: '7px',
                }}
                key={index}
              >
                <CancelIcon
                  sx={{
                    position: 'absolute',
                    fontSize: '20px',
                    top: 1,
                    right: 1,
                    zIndex: +1,
                    cursor: 'pointer',
                  }}
                  onClick={() => handleDeleteImage(input, index)}
                />
                <Box
                  component="img"
                  src={URL.createObjectURL(input)}
                  sx={{
                    height: '54px',
                    width: '54px',
                    aspectRatio: '1/1',
                    borderRadius: '8px',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    setCategoryAddInputDatas({
                      ...categoryAddInputDatas,
                      indexPreviePhoto: index + 1,
                      isPreviewPhoto: 'true',
                    });
                  }}
                />
              </Box>
            ))}
          </Box>

          <Box
            sx={{
              display: 'flex',
              mb: '7px',
              ml: '20px',
              alignItems: 'center',
            }}
          >
            {categoryAddInputDatas.photo.length < 3 && (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  color: theme.palette.primary.main,
                  cursor: 'pointer',
                }}
                onClick={() => {
                  document.getElementById('input_img').click();
                }}
              >
                <input
                  accept="image/*"
                  id="input_img"
                  type="file"
                  style={{ display: 'none' }}
                  onChange={handleAddImage}
                />
                <AddIcon />
                <Typography sx={{ fontSize: '14px', fontWeight: '600' }}>
                  Add More
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      </Grid>
      {/* //* Dialog Photo */}
      {categoryAddInputDatas.indexPreviePhoto !== 0 && (
        <Dialog
          open={categoryAddInputDatas.isPreviewPhoto}
          onClose={() => {
            setCategoryAddInputDatas({
              ...categoryAddInputDatas,
              isPreviewPhoto: !categoryAddInputDatas.isPreviewPhoto,
            });
          }}
        >
          <Box
            component="img"
            src={URL.createObjectURL(
              categoryAddInputDatas.photo[
                categoryAddInputDatas.indexPreviePhoto - 1
              ]
            )}
            sx={{ width: '600px', height: '600px', aspectRation: '1/1' }}
          />
        </Dialog>
      )}
      {/* //* Description */}
      <Grid item xs={6}>
        <Typography sx={{ mb: '16px', fontSize: '16px', fontWeight: '500' }}>
          Description
        </Typography>
        <CustomInput
          sx={{ width: '100%', bgcolor: '#FAFAFA' }}
          placeholder="Enter description"
          value={categoryAddInputDatas.description}
          onChange={(e) => {
            if (e.target.value.length <= 250) {
              setCategoryAddInputDatas({
                ...categoryAddInputDatas,
                description: e.target.value,
              });
            }
          }}
        />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography
            sx={{
              fontSize: '12px',
              fontWeight: '400',
              color: '#9E9D9D',
              mt: '4px',
            }}
          >
            Enter at least 20 character
          </Typography>
          <Typography
            sx={{
              fontSize: '12px',
              fontWeight: '400',
              color: '#9E9D9D',
              mt: '4px',
            }}
          >
            {categoryAddInputDatas.description.length}/250
          </Typography>
        </Box>
      </Grid>
      {/* //* Type */}
      {/* <Grid item xs={6}>
        <Typography sx={{ mb: '16px', fontSize: '16px', fontWeight: '500' }}>
          Type*
        </Typography>
        <Autocomplete
          options={typeCategory}
          getOptionLabel={(option) => option.nmOpsi}
          inputValue={categoryAddInputDatas.typeInput}
          onInputChange={(_, newValue) => {
            setCategoryAddInputDatas({
              ...categoryAddInputDatas,
              typeInput: newValue,
            });
          }}
          value={categoryAddInputDatas.type}
          onChange={(_, newValue) => {
            setCategoryAddInputDatas({
              ...categoryAddInputDatas,
              type: newValue,
              typeId: newValue.iDopsi,
              typeName: newValue.nmOpsi,
            });
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              sx={{ bgcolor: '#FAFAFA' }}
              placeholder="Select Type"
            />
          )}
          loading={typeCategoryLoading}
        />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography
            sx={{
              fontSize: '12px',
              fontWeight: '400',
              color: '#9E9D9D',
              mt: '4px',
            }}
          >
            Enter at least 20 character
          </Typography>
          <Typography
            sx={{
              fontSize: '12px',
              fontWeight: '400',
              color: '#9E9D9D',
              mt: '4px',
            }}
          >
            {categoryAddInputDatas.description.length}/250
          </Typography>
        </Box>
      </Grid> */}
      {/* //* Schedule */}
      <Grid item xs={6} sx={{}}>
        <Grid container>
          <Grid item alignItems="center" sx={{ height: '100%', mr: '20px' }}>
            <Typography
              sx={{
                mb: '16px',
                fontSize: '16px',
                fontWeight: '500',
              }}
            >
              Schedule
            </Typography>
          </Grid>
          <Grid item alignItems="center" sx={{ height: '100%' }}>
            <RadioGroup
              row
              value={categoryAddInputDatas.scheduleType}
              onChange={(e) => {
                setCategoryAddInputDatas({
                  ...categoryAddInputDatas,
                  schedule: today,
                  scheduleType: e.target.value,
                });
              }}
              sx={{
                '& .MuiSvgIcon-root': {
                  fontSize: '16px',
                },
                '.MuiRadio-root': {
                  padding: '0 8px',
                },
                '.MuiTypography-root': {
                  fontSize: '12px',
                },
              }}
            >
              <FormControlLabel value="now" control={<Radio />} label="Now" />
              <FormControlLabel
                value="custom"
                control={<Radio />}
                label="Custom"
              />
            </RadioGroup>
          </Grid>
        </Grid>
        <Box sx={{ display: 'flex', minWidth: '100%' }}>
          <DesktopDatePicker
            inputFormat="DD/MM/YYYY"
            value={categoryAddInputDatas.schedule}
            onChange={(newValue) => {
              if (categoryAddInputDatas.scheduleType !== 'now') {
                setCategoryAddInputDatas({
                  ...categoryAddInputDatas,
                  schedule: newValue,
                });
              } else {
                setCategoryAddInputDatas({
                  ...categoryAddInputDatas,
                  schedule: today,
                });
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                sx={{ width: '100%', bgcolor: '#FAFAFA' }}
              />
            )}
            disabled={
              categoryAddInputDatas.scheduleType === 'now' ? true : false
            }
          />
        </Box>
      </Grid>

      {/* //*Add Sub Category */}
      {categoryAddInputDatas.subCategoryIndex.length === 0 && (
        <Grid item xs={6}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              color: theme.palette.primary.main,
            }}
            onClick={handleAddSub}
          >
            <AddIcon
              sx={{
                fontSize: '20px',
                cursor: 'pointer',
              }}
            />
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: '600',
                cursor: 'pointer',
              }}
            >
              Add Sub
            </Typography>
          </Box>
        </Grid>
      )}
      {categoryAddInputDatas.subCategoryIndex.length !== 0 && (
        <Grid item xs={12}>
          <CustomCard sx={{ padding: '20px 16px ' }}>
            <Grid container columns={12} rowSpacing={5}>
              {indexSubCategory.length !== 0 && (
                <Grid item xs={12} sx={{ mb: '5px' }}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      color: theme.palette.primary.main,
                    }}
                    onClick={() => {
                      const value = indexSubCategory[0];
                      setCategoryAddInputDatas({
                        ...categoryAddInputDatas,
                        subCategoryIndex: [
                          ...categoryAddInputDatas.subCategoryIndex,
                          value,
                        ],
                      });
                      setIndexSubCategory(
                        indexSubCategory.filter((nilai) => nilai !== value)
                      );
                    }}
                  >
                    <AddIcon
                      sx={{
                        fontSize: '20px',
                        cursor: 'pointer',
                      }}
                    />
                    <Typography
                      sx={{
                        fontSize: '14px',
                        fontWeight: '600',
                        cursor: 'pointer',
                      }}
                    >
                      Add Sub
                    </Typography>
                  </Box>
                </Grid>
              )}
              {categoryAddInputDatas.subCategoryIndex.map((nilai, index) => (
                <Grid
                  container
                  item
                  xs={12}
                  columns={12}
                  columnSpacing={4}
                  rowSpacing={2}
                  key={index}
                >
                  <AddSubCategoryInCategory
                    {...{
                      setPage,
                      categoryAddInputDatas,
                      setCategoryAddInputDatas,
                      indexSubCategory,
                      setIndexSubCategory,
                      isSubmitAvailable,
                      setIsSubmitAvailable,
                    }}
                    sub={nilai === 1 ? sub1 : nilai === 2 ? sub2 : sub3}
                    setSub={
                      nilai === 1 ? setSub1 : nilai === 2 ? setSub2 : setSub3
                    }
                    id={nilai}
                  />
                  {categoryAddInputDatas.subCategoryIndex[
                    categoryAddInputDatas.subCategoryIndex.length - 1
                  ] !== nilai && (
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>
                  )}
                </Grid>
              ))}
            </Grid>
          </CustomCard>
        </Grid>
      )}

      {/* //* Submit FOrm */}
      <Box
        sx={{
          width: '100%',
          bgcolor: 'white',
          position: 'fixed',
          bottom: '0px',
          right: '0px',
          display: 'flex',
          justifyContent: 'space-between',
          padding: '18px 32px 18px 240px',
          alignItems: 'center',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>
            Publish
          </Typography>
          <AntSwitch
            checked={categoryAddInputDatas.publish}
            onChange={(e) => {
              setCategoryAddInputDatas({
                ...categoryAddInputDatas,
                publish: !categoryAddInputDatas.publish,
              });
            }}
          />
        </Box>
        <Box sx={{ display: 'flex' }}>
          <CustomButton
            variant="contained"
            disabled={!isSubmitAvailable}
            onClick={handleAdd}
            sx={{ width: '140px', height: '36px' }}
          >
            <Typography
              sx={{ color: 'white', fontSize: '12px', fontWeight: '500' }}
            >
              Submit
            </Typography>
          </CustomButton>
        </Box>
      </Box>
    </Grid>
  );
};

export default CategoryMenuAddDesktop;
